import jwtDecode from 'jwt-decode'
import { getAuthToken } from 'src/services/auth-service.js'

export default function isLoggedIn () {
  const authToken = getAuthToken()
  return authToken && !isJwtExpired(authToken)
}

function isJwtExpired (token) {
  try {
    const { exp } = jwtDecode(token)
    const currentTime = Date.now() / 1000
    return exp < currentTime
  } catch (error) {
    return true
  }
}
